<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{tipo === 1 ? ('grupos' | nomenclatura | async) : ('ministerios' | nomenclatura | async)}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <ion-card>
    <div class="title ion-margin-top">
      <ion-note slot="start">
        <i class="fas fa-users"></i>
      </ion-note>

      <ion-label>
        {{'Meus ' | translate}} {{tipo === 1 ? ('grupos' | nomenclatura | async) : ('ministerios' | nomenclatura | async)}}
      </ion-label>
      <p [hidden]="!grupos.length">
        {{grupos.length}} {{tipo === 1 ? ('grupos' | nomenclatura | async) : ('ministerios' | nomenclatura | async)}} {{' cadastrados' | translate}}
      </p>
    </div>

    <ion-list *ngFor="let g of grupos" [hidden]="!grupos.length">
      <ion-item (click)="selecionarGrupo(g)" class="pointer">
        <ion-label class="dados-grup">
          <h3 class="bold-2">{{g.nome}}</h3>
          <p class="tipo">{{g.grupoTipo}} <span *ngIf="g.cargo"> | {{g.cargo}}</span></p>
          <p class="data" *ngIf="g.data_entrada">{{'Desde' | translate}} {{g.data_entrada |
            dateFormat:"media"}}</p>
        </ion-label>
        <ion-icon class="icon-list" slot="end" name="arrow-forward-sharp"></ion-icon>
      </ion-item>
    </ion-list>
  </ion-card>
  <sem-registro [hidden]="grupos"></sem-registro>
</ion-content>